import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import React from 'react';
import { FormFieldProps } from 'lib/forms/FormFieldProps';
import { Field } from 'formik';
import { getValueProviderValue } from 'lib/forms/FormFieldUtils';

export type HiddenProps = Feature.EnterpriseWeb.Enterprise.Forms.Fields.Hidden & FormFieldProps;

export const getInitialValue = (
  props: HiddenProps,
  additionalDetails?: Record<string, unknown> | undefined
) => {
  const valueProvider = getValueProviderValue(props, additionalDetails);
  if (valueProvider) {
    return valueProvider;
  } else if (props?.fields?.defaultValue) {
    return props?.fields?.defaultValue?.value || '';
  }
};

const Hidden = (props: HiddenProps): JSX.Element => {
  return (
    <div className="relative mb-s" data-te-input-wrapper-init>
      <Field id={props.id} name={props?.fields?.fieldName?.value || props.id} type="hidden" />
    </div>
  );
};

export default Hidden;
